module.exports = __webpack_public_path__ + "img/User Interface Design_Silicon Stone Education_20200905.d02d0e3e.jpg";